/**
 * The default ARIA label for previous month button in navigation
 */
export var labelPrevious = function () {
    return 'Go to previous month';
};
//# sourceMappingURL=labelPrevious.js.map